<template>

  <div class="PayBill">
    <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:100vh" variant="dark"
      id="loader">
      <b-row>
        <b-col cols="12 headerF">
          <HeaderFixed />
        </b-col>
        <b-col cols="12 headerM">
          <HeaderMobile />
        </b-col>
      </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
            <b-breadcrumb style=" background-color: #e9ecef78;">
              <b-breadcrumb-item href="#home">
                <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                  Home
                </router-link>
              </b-breadcrumb-item>

              <b-breadcrumb-item href="#" active>Smart Prepaid Balance</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">KNOW YOUR SMART PREPAID BALANCE</span>
          </b-col>
        </b-row>
        <hr />
        <div class="paddingLeft30px">
          <br>
          <!-- <p style="color:red;">
          We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.
        </p> -->


          <b-row>
            <b-col col cols="5" sm="5" md="2" lg="2" style="padding-top: 7px;">
              <span style="font-weight:600">Consumer No <span class="text-danger">*</span></span>
            </b-col>
            <b-col col cols="7" sm="7" md="3" lg="3" style="padding-top: 5px;">
              <b-form-input type="text" id="consNo" value="" placeholder="Enter Consumer Number" trim />
            </b-col>
            <b-col col cols="5" sm="5" md="3" lg="2" style="padding-top: 5px;">
              <img id="captcha" src="#" alt="captcha">
              <a href="#" @click="generateCaptcha()"><b-icon icon="arrow-clockwise" font-scale="1.8"
                  style="padding-top:7px"></b-icon></a>

            </b-col>
            <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;">
              <b-form-input type="number" id="result" placeholder="Answer" style="padding-top: 7px;" />
            </b-col>

            <b-col col cols="3" sm="3" md="2" lg="1" style="padding-top: 5px;">
              <b-button @click="verifyCaptcha()" block pill variant="primary" size="md" class="go" style="width:100%">
                <b-icon icon="arrow-right-short" animation="" scale="1.8"> </b-icon>
              </b-button>

            </b-col>
          </b-row>
          <br>
          <b-card no-body id="showDetailsDiv" style="display:none">
            <b-row class="paddingRow">
              <b-col cols="12" sm="4" md="1" lg="1">
                <span class="label">Name: </span>
              </b-col>
              <b-col cols="12" sm="8" md="3" lg="3">
                <span class="" id="consName"></span>
              </b-col>

              <b-col cols="12" sm="4" md="2" lg="2">
                <span class="label">Balance: </span>
              </b-col>
              <b-col cols="12" sm="8" md="2" lg="2">
                <span class="" id="balance" style="font-weight:600;font-size:1.5rem"></span>
              </b-col>

              <b-col cols="12" sm="12" md="3" lg="3">
                <b-button variant="primary" id="showMoreDetailsBtn" @click="showMore()">View More Details</b-button>
              </b-col>
            </b-row>

          </b-card>
          <b-card no-body id="showMoreDetailsDiv" style="display:none;">
            <b-tabs card fill v-model="tabIndex">
              <b-tab title="Recharge History">
                <div id="noRechargeHistoryDiv" style="display:none;">
                  <span style="font-weight:600;font-size:1.3rem"> No Recharge History Found</span>
                  <br>
                </div>
                <div id="rechargeHistoryDiv">
                  <b-table responsive :items="rechargeHistory" :fields="rechargeHistoryFields"
                    style="font-size:0.8rem;text-align:center">
                    <template v-slot:cell(action)="data">
                      <span v-html="data.value"></span>
                    </template>
                  </b-table>
                </div>
              </b-tab>

              <b-tab title="Clear Postpaid Due">
                <div id="noDuesDiv" style="display:none">
                  <span style="font-weight:600;font-size:1.3rem" id="serverMessage"></span>
                  <br>
                </div>

                <div id="balanceReceiptDiv" style="display:none">
                  <br>
                  <strong> Outstandig Clearance Receipt</strong>
                  <b-table responsive :items="balanceHistory" :fields="rechargeHistoryFields"
                    style="font-size:0.8rem;text-align:center">
                    <template v-slot:cell(action)="data">
                      <span v-html="data.value"></span>
                    </template>
                  </b-table>
                </div>
                <div id="duesDiv" style="display:none">
                  <b-row class="paddingRow">
                    <b-col cols="12" sm="2" md="2" lg="2">
                      <span class="label">Name: </span>
                    </b-col>
                    <b-col cols="12" sm="2" md="4" lg="4">
                      <span class="" id="cName">a</span>
                    </b-col>
                    <b-col cols="12" sm="2" md="2" lg="2">
                      <span class="label">Address: </span>
                    </b-col>
                    <b-col cols="12" sm="2" md="4" lg="4">
                      <span class="" id="address">a</span>
                    </b-col>
                  </b-row>
                  <b-row class="paddingRow">
                    <b-col cols="12" sm="2" md="2" lg="2">
                      <span class="label">Bill Number: </span>
                    </b-col>
                    <b-col cols="12" sm="2" md="4" lg="4">
                      <span class="" id="billNo"></span>
                    </b-col>
                    <b-col cols="12" sm="2" md="2" lg="2">
                      <span class="label">Bill Date: </span>
                    </b-col>
                    <b-col cols="12" sm="2" md="4" lg="4">
                      <span class="" id="billDate"></span>
                    </b-col>
                  </b-row>

                  <b-row class="paddingRow">
                    <b-col cols="12" sm="2" md="2" lg="2">
                      <span class="label">Due Amount: </span>
                    </b-col>
                    <b-col cols="12" sm="2" md="7" lg="7">
                      <span class="" style="color:red;font-weight:600;font-size:1.3rem" id="dueAmount"></span>
                    </b-col>
                  </b-row>
                  <b-row class="paddingRow">
                    <b-col cols="12" sm="2" md="2" lg="2">
                      <span class="label">Mobile No: <span style="color:red">*</span></span>
                    </b-col>
                    <b-col cols="12" sm="2" md="4" lg="4">
                      <span class=""> <b-form-input type="number" id="mobileNo" class="inputWidth"
                          placeholder="Mobile No" trim /></span>
                    </b-col>
                    <b-col cols="12" sm="2" md="2" lg="2">
                      <span class="label">Email Id: </span>
                    </b-col>
                    <b-col cols="12" sm="2" md="4" lg="4">
                      <span class=""> <b-form-input type="email" id="emailId" class="inputWidth" placeholder="Email ID"
                          trim /></span>
                    </b-col>
                  </b-row>
                  <br></br>
                  <b-row class="paddingRow">
                    <b-col cols="12" sm="2" md="3" lg="3" offset-lg="4">
                      <b-button block squared variant="primary" class="marginTop" @click="payNow()">
                        <b-icon icon="credit-card" animation=""> </b-icon> PAY NOW
                      </b-button>

                    </b-col>
                  </b-row>

                </div>
              </b-tab>
              <!-- <b-tab title="Monthly Statement">
                <b-row class="paddingRow">
                  <b-col cols="12" sm="2" md="2" lg="2">
                    Month:
                  </b-col>
                  <b-col cols="12" sm="3" md="3" lg="3">
                    <b-form-select v-model="selectedMonth" :options="monthOptions"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="paddingRow">
                  <b-col cols="12" sm="2" md="2" lg="2">
                    Year:
                  </b-col>
                  <b-col cols="12" sm="3" md="3" lg="3">
                    <b-form-select v-model="selectedYear" :options="yearOptions"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="paddingRow">
                  <b-col cols="12" sm="2" md="3" lg="3" offset-lg="2">
                    <b-button block squared variant="primary" class="marginTop" @click="viewStatement()">
                      <b-icon icon="credit-card" animation=""> </b-icon> VIEW STATEMENT
                    </b-button>
                  </b-col>
                </b-row>
              </b-tab> -->
            </b-tabs>
          </b-card>
        </div>
      </b-container>

      <b-container id="billdeskRequestDiv" fluid style="padding-top: 100px;text-align:left;display:none">
        <br><br>
        <b-row id="spinner" style="display:block">
          <b-col cols=12 align="center">
            <h3 class="">Processing Payment Request...</h3>
            <br><br>
            <b-spinner style="width: 10rem; height: 10rem;" variant="primary" label="Spinning"></b-spinner>
            <br><br><br>
            <h5 style="color:red">Please do not press back or refresh button</h5>
          </b-col>
        </b-row>
        <b-row id="errorDiv" style="display:none">
          <b-col cols=12 align="center">
            <h2 style="color:red" id="errorMsg"></h2>
            <br><br>
            <b-button onclick="window.location.reload();">Go Back</b-button>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
    </b-overlay>
    <form :action="reqUrl" method="post" id="pgrequest" hidden>
      <input type="" name="msg" :value="messageToSend" hidden>
      <input type="submit" id="submit" value="submit" hidden>
    </form>
    <b-modal id="model" centered scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="msg"> </span>
      <br><br>
      <b-button style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="otpModal" centered no-close-on-esc no-close-on-backdrop title="OTP Verification" hide-footer>
      <b-overlay :show="show1" spinner-variant="primary" spinner-large rounded="sm" style="" variant="dark" id="loader">
        Enter the OTP received in your mobile number
        <b-form-input type="number" id="otp"></b-form-input><br>
        <b-button class="btn" variant="primary" id="success-btn" @click="verifyOtp()">Verify</b-button> &nbsp&nbsp
        <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()">Resend OTP</b-button>
      </b-overlay>
    </b-modal>

  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
var consNo = "";
var sdCode = "";
var thColor = '#0288d1';
var rechargeData = [];
var balanceData = [];
var billText = "";
var duplicate = ""
var rn = "";
var dn = "";
var invoice = "";
var transactionId = "";
var consNo = "";
var address = "";
var esd = "";
var name = "";
var billAmount = "";
var printDueAmount = "";
var mode = "";
var amountRcvd = "";
var paymentDate = "";
var paymentInWords = "";
var ov = "N";




var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];



export default {
  name: 'PayBill',
  components: {

    'HeaderFixed': HeaderFixed,
    'HeaderMobile': HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      consumerNo: '',
      show: false,
      tabIndex: 0,
      show1: false,
      message: [
        "",
        "No Consumer Found for this Consumer Number",
        "No Outstanding Bill Found for this Consumer Number",
        "This Consumer Number is Blocked",
        "No Bill Found for Payment",
        "",
        "Server Busy! Kindly Try Again After Sometime.",
        "Transaction Already in Progress",
        "Error in Initiating Payment Request with Billdesk"
      ],
      messageToSend: "",
      reqUrl: "",
      rechargeHistoryFields: [
        { key: 'consNo', label: 'Consumer No.', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' }, thClass: 'paddingTh', tdClass: 'paddingTd' },
        { key: 'paidAmt', label: 'Paid Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' }, thClass: 'paddingTh', tdClass: 'paddingTd' },
        { key: 'paymentMode', label: 'Payment Mode', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' }, thClass: 'paddingTh', tdClass: 'paddingTd' },
        { key: 'txnDate', label: 'Transaction Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' }, thClass: 'paddingTh', tdClass: 'paddingTd' },
        { key: 'receiptNo', label: 'Receipt No', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: '' }, thClass: 'paddingTh', tdClass: 'paddingTd' },
        { key: 'action', label: 'View Receipt', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: '' }, thClass: 'paddingTh', tdClass: 'paddingTd' }
      ],
      rechargeHistory: [],

      selectedMonth: null,
      monthOptions: [
        { value: null, text: 'Please select month' },
        { value: '01', text: 'January' },
        { value: '02', text: 'February' },
        { value: '03', text: 'March' },
        { value: '04', text: 'April' },
        { value: '05', text: 'May' },
        { value: '06', text: 'June' },
        { value: '07', text: 'July' },
        { value: '08', text: 'August' },
        { value: '09', text: 'September' },
        { value: '10', text: 'October' },
        { value: '11', text: 'November' },
        { value: '12', text: 'December' }
      ],
      selectedYear: null,
      yearOptions: [],
      balanceHistory: []

    }
  },
  methods: {
    printSMPdf() {
      var docDefinition = {
        content: [
          {
            alignment: 'center',
            text: 'ASSAM POWER DISTRIBUTION COMPANY LIMITED',
            style: 'header',
            fontSize: 15,
            bold: true,
            margin: [0, 0, 0, 5],
          },
          {
            alignment: 'center',
            text: billText,
            fontSize: 10,
            margin: [0, 0, 0, 5],
          },
          {
            alignment: 'center',
            text: duplicate,
            fontSize: 10,
            margin: [0, 0, 0, 5],
          },
          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 661, y2: 0, lineWidth: 1 }] },
          {
            margin: [10, 10, 0, 0],
            fontSize: 10,
            columns: [
              {
                text: "Receipt No",
              },
              {
                text: ': ' + rn,
              },
              {
                text: 'D/T : ' + dn,
              },
            ]
          },
          {
            margin: [10, 3, 0, 0],
            fontSize: 10,
            columns: [
              {
                text: "Consumer No",
              },
              {
                text: ': ' + consNo,
              },
              {
                text: "Sub Division : " + esd,
              },
            ]
          },
          {
            margin: [10, 3, 0, 0],
            fontSize: 10,
            columns: [
              {
                text: "Name",
              },
              {
                text: ': ' + name,
              },
              {
                text: "Txn ID : " + transactionId,
              },
            ]
          },
          {
            margin: [10, 3, 0, 0],
            fontSize: 10,
            columns: [
              {
                text: "Address",
              },
              {
                text: ': ' + address,
              },
              {
                text: " ",
              },
            ]
          },
          {
            margin: [10, 3, 0, 0],
            fontSize: 10,
            columns: [
              {
                text: "Payment Mode",
              },
              {
                text: ': ' + mode,
              },
              {
                text: " ",
              },
            ]
          },
          {
            margin: [10, 3, 0, 0],
            fontSize: 10,
            columns: [
              {
                text: "Amount Received",
              },
              {
                text: ': ' + amountRcvd,
              },
              {
                text: "",
              },
            ]
          },
          {
            margin: [10, 3, 0, 0],
            fontSize: 10,
            columns: [
              {
                text: "Payment Date",
              },
              {
                text: ': ' + paymentDate,
              },
              {
                text: " ",
              },
            ]
          },
          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 661, y2: 0, lineWidth: 1 }] },

        ],
        pageSize: {
          width: 720,
          height: 288
        },

        pageOrientation: 'landscape',
        pageMargins: [20, 15, 20, 15]
      };


      pdfMake.createPdf(docDefinition).open();

    },
    inWords(num) {
      if ((num = num.toString()).length > 9) return 'overflow';
      n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!n) return; var str = '';
      str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
      str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
      str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
      str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
      str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
      return str;
    },
    generateCaptcha() {
      axios.post(this.$urlCommon + "/api/web/getCaptcha").then(function (response) {
        //console.log(response.data);
        document.getElementById("captcha").src = "data:image/png;base64," + response.data;

      })
    },

    verifyCaptcha() {
      var parent = this;
      consNo = document.getElementById("consNo").value;
      if ((consNo.toString().length != 12)) {
        this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var result = document.getElementById("result").value;
      if ((result == "")) {
        this.$bvToast.toast('Enter Captcha !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return;
      }

      this.showDetails();
    },

    showDetails() {
      this.tabIndex = 0;
      consNo = document.getElementById("consNo").value;
      console.log("consNo length" + consNo.length)
      if (consNo.length != 12) {
        this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("consNo").focus();
        document.getElementById("showDetailsDiv").style.display = "none";
        return;
      }
      this.show = true;
      var parent = this;
      parent.consumerBill = [];
      var result = document.getElementById("result").value;

      document.getElementById("showMoreDetailsDiv").style.display = "block";
      axios.post(this.$urlCommon + '/api/web/knowYourSmartBalance/getConsumerDetails?consNo=' + consNo + '&result=' + result)
        .then((response) => {
          // console.log("get consumer details"+response.data);
          parent.show = false;
          var consData = response.data.consDetails;
          var msg = response.data.msg;



          if (msg == "success") {
            parent.generateCaptcha();
            document.getElementById("showMoreDetailsDiv").style.display = "none";
            document.getElementById("showDetailsDiv").style.display = "block";
            document.getElementById("consName").innerHTML = consData.consName;

            if (parseFloat(consData.availableBalance) <= 0)
              document.getElementById("balance").innerHTML = '<span style="color:red;">' + consData.availableBalance + '</span>';
            else if (parseFloat(consData.availableBalance) <= 100 && parseFloat(consData.availableBalance) > 0)
              document.getElementById("balance").innerHTML = '<span style="color:orange;">' + consData.availableBalance + '</span>';
            else if (parseFloat(consData.availableBalance) > 0)
              document.getElementById("balance").innerHTML = '<span style="color:green;">' + consData.availableBalance + '</span>';

          }

          else if (msg == "failure") {
            parent.generateCaptcha();
            document.getElementById("showDetailsDiv").style.display = "none";
            parent.$bvModal.show("model");
            document.getElementById("msg").innerHTML = response.data.errorMsg1;
            // document.getElementById("msg").innerHTML="Error on Server Side";

          }

          else {
            parent.generateCaptcha();
            document.getElementById("showDetailsDiv").style.display = "none";
            parent.$bvModal.show("model");
            document.getElementById("msg").innerHTML = "Sorry Consumer / Data not Found";

          }
        })
        .catch((e) => {
          console.log("Caught", e);
          parent.show = false;
          parent.$bvModal.show("model");
          document.getElementById("msg").innerHTML = "Sorry, Consumer / Data not Found";

        })




    },

    showMore() {
      var parent = this;

      consNo = document.getElementById("consNo").value;

      if ((consNo.toString().length != 12)) {
        this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return;
      }

      parent.show = true;

      axios.post(parent.$urlCommon + '/api/otp/sendConsumerOTP?consNo=' + consNo)
        .then((response) => {

          //  console.log("inside show more"+response.data);
          var data = response.data;
          var status = data.msg;

          if (status == "success") {

            if (data.otpGenerated == "Y") {
              parent.$bvToast.toast('OTP Sent Successfully !', {
                title: `Success`,
                variant: 'success',
                solid: true
              });
              parent.$bvModal.show('otpModal');

            }
            else {
              parent.$bvToast.toast('OTP Generation Failed !', {
                title: `Failed`,
                variant: 'danger',
                solid: true
              });
            }

          }

          else {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Consumer Not Found";

          }

        })
        .catch((e) => {
          console.log("Caught", e);
          this.show = false;
        })


    },
    resendOtp() {
      var parent = this;

      parent.show1 = true;
      // resend otp api change
      // axios.post(this.$urlArms+"/Rstapi/website/resendOTP?consNo="+consNo).then(function(response) {
      axios.post(this.$urlCommon + "/website/api/otp/sendConsumerOTP?consNoc=" + consNo + "&type=resend").then(function (response) {
        parent.show1 = false;
        if (response.data.msg == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
        else {
          parent.$bvToast.toast('OTP Could not Sent !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });
        }
      });
    },
    verifyOtp() {
      var parent = this;

      var otp = document.getElementById("otp").value;

      parent.show1 = true;

      axios.post(parent.$urlCommon + "/api/web/knowYourSmartBalance/getRechargeHistory?consNo=" + consNo + "&otp=" + otp).then(function (response) {

        if (response.data.status == "success") {
          parent.$bvToast.toast('OTP Verified Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
          parent.$bvModal.hide('otpModal');
          document.getElementById("showMoreDetailsBtn").style.display = "none";
          document.getElementById("showMoreDetailsDiv").style.display = "block";
          ov = "Y";

          console.log("response.data.rechargeHistory::::" + response.data.rechargeHistory)

          parent.getRechargeHistory(response.data.rechargeHistory);
          parent.clearPostpaidDues(response.data.postPaidOutstanding);
        }
        else {
          parent.show1 = false;
          parent.$bvToast.toast(response.data.message, {
            title: `Alert`,
            variant: 'danger',
            solid: true
          });
        }
      })
        .catch((e) => {
          parent.show = false;
          parent.$bvModal.show('model');
          document.getElementById("msg").innerHTML = "Sorry, Please Try Again Later";
          console.log("Caught :::::::::::::::", e.message);

        })
    },
    getRechargeHistory(dataRechargeHistory) {
      var dataFetch = dataRechargeHistory;
      // console.log(dataFetch[0].cons_no);

      var parent = this;
      this.show = false;
      var temp = [];
      var i = 0;
      rechargeData = dataFetch;

      console.log("re::::" + dataFetch.length)
      if (dataFetch == "") {
        document.getElementById("noRechargeHistoryDiv").style.display = "block";
        document.getElementById("rechargeHistoryDiv").style.display = "none";
      }
      else if (dataFetch[0].cons_no == "N/A" || dataFetch.length == 0) {
        document.getElementById("noRechargeHistoryDiv").style.display = "block";
        document.getElementById("rechargeHistoryDiv").style.display = "none";
      }

      else {
        dataFetch.forEach(element => {
          var res1 = element.date.split("-");
          var dateFormatted = res1[2] + "/" + res1[1] + "/" + res1[0];
          var mode = "";
          if (element.mode === null)
            mode = "Cash/Cheque";
          else mode = "Online";
          var obj = {
            "consNo": element.cons_no,
            "paidAmt": element.amount,
            "paymentMode": mode,
            "txnDate": dateFormatted,
            "receiptNo": element.receipt_no,
            "action": "<a  onclick='downloadReceipt(" + i + ")'><img  src='https://www.apdcl.org/website/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
          }
          temp.push(obj)
          i++;
        })
        console.log(temp)
        parent.rechargeHistory = temp
      }
    },

    downloadReceipt(i) {

      console.log("receiptCalled", JSON.stringify(rechargeData[i]));

      billText = "SMART PREPAID PAYMENT RECEIPT";
      rn = rechargeData[i].receipt_no;
      dn = new Date().toLocaleString('en-GB');
      transactionId = rechargeData[i].transactionId.trim() == "" ? "NA" : rechargeData[i].transactionId;
      consNo = rechargeData[i].cons_no;
      address = rechargeData[i].address;
      esd = rechargeData[i].subdivision;
      name = rechargeData[i].name;
      if (rechargeData[i].mode === null)
        mode = "Cash/Cheque";
      else mode = "Online";
      amountRcvd = rechargeData[i].amount;
      paymentDate = rechargeData[i].date.split('-').reverse().join('/');
      this.printSMPdf();
    },

    downloadReceiptBalance(i) {

      console.log("receiptCalled", JSON.stringify(balanceData[i]));

      billText = "OUTSTANDING CLEARANCE RECEIPT";
      rn = balanceData[i].receipt_no;
      dn = new Date().toLocaleString('en-GB');
      transactionId = balanceData[i].transactionId.trim() == "" ? "NA" : balanceData[i].transactionId;
      consNo = balanceData[i].cons_no;
      address = balanceData[i].address;
      esd = balanceData[i].subdivision;
      name = balanceData[i].name;
      if (balanceData[i].mode === null)
        mode = "Cash/Cheque";
      else mode = "Online";
      amountRcvd = balanceData[i].amount;
      paymentDate = balanceData[i].date.split('-').reverse().join('/');
      this.printSMPdf();
    },

    clearPostpaidDues(outstandingData) {
      // console.log("outstandingData::"+outstandingData.data[0]);
      consNo = document.getElementById("consNo").value;

      this.show = false;
      var parent = this;
      var consData = outstandingData;
      console.log("consData::::" + JSON.stringify(consData));

      if (consData.status == 'success') {
        var res1 = consData.data.bill_DATE.split("-");
        var newDateFormat = res1[2] + "/" + res1[1] + "/" + res1[0];
        balanceData = outstandingData.data;
      }
      else if (consData.status == 'failure' && consData.data.length > 0) {
        var res1 = consData.data[0].date.split("-");
        var newDateFormat = res1[2] + "/" + res1[1] + "/" + res1[0];
        balanceData = outstandingData.data;
      }

      // var res1= consData.date.split("-");
      // var newDateFormat = res1[2]+"/"+res1[1]+"/"+res1[0];
      // balanceData = outstandingData.data;
      // if(consData.status=='success' && consData.data.rem_AMT>1) {
      //     document.getElementById("duesDiv").style.display="block";
      //     document.getElementById("noDuesDiv").style.display="none";
      //     document.getElementById("balanceReceiptDiv").style.display="none";
      //     document.getElementById("cName").innerHTML=consData.name;
      //     document.getElementById("address").innerHTML=consData.address;
      //     document.getElementById("billNo").innerHTML=consData.receipt_no;
      //     document.getElementById("billDate").innerHTML=newDateFormat;
      //     document.getElementById("dueAmount").innerHTML=consData.amount.toString().split('.')[0];
      //   }
      if (consData.status == 'success' && consData.data.rem_AMT > 1) {
        document.getElementById("duesDiv").style.display = "block";
        document.getElementById("noDuesDiv").style.display = "none";
        document.getElementById("balanceReceiptDiv").style.display = "none";
        document.getElementById("cName").innerHTML = consData.data.cons_NAME;
        document.getElementById("address").innerHTML = consData.data.cons_ADD1;
        document.getElementById("billNo").innerHTML = consData.data.bill_NO;
        document.getElementById("billDate").innerHTML = consData.data.bill_DATE;
        document.getElementById("dueAmount").innerHTML = consData.data.rem_AMT.toString().split('.')[0];
      }
      else if (outstandingData.status == 'failure' && outstandingData.message == "You have no outstanding to be cleared." && outstandingData.data.length != 0) {
        console.log("data length:::" + outstandingData.data.length)
        document.getElementById("duesDiv").style.display = "none";
        document.getElementById("noDuesDiv").style.display = "block";
        document.getElementById("balanceReceiptDiv").style.display = "block";
        document.getElementById("serverMessage").innerHTML = "<span style='color:green'>" + outstandingData.message + "</span>";
        var temp = [];
        var i = 0;
        outstandingData.data.forEach(element => {
          var res1 = element.date.split("-");
          var dateFormatted = res1[2] + "/" + res1[1] + "/" + res1[0];
          var mode = "";
          if (element.mode === null)
            mode = "Cash/Cheque";
          else mode = "Online";
          var obj = {
            "consNo": element.cons_no,
            "paidAmt": element.amount,
            "paymentMode": mode,
            "txnDate": dateFormatted,
            "receiptNo": element.receipt_no,
            "action": "<a  onclick='downloadReceiptBalance(" + i + ")'><img  src='https://www.apdcl.org/website/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
          }
          temp.push(obj)
          i++;
          // console.log(temp)
          // parent.balanceHistory = temp

        })
        console.log(temp)
        parent.balanceHistory = temp
      }
      else if (consData.status == 'failure' && consData.data.length === 0) {
        document.getElementById("duesDiv").style.display = "none";
        document.getElementById("noDuesDiv").style.display = "block";
        document.getElementById("balanceReceiptDiv").style.display = "none";
        document.getElementById("serverMessage").innerHTML = "<span style='color:red'>" + outstandingData.message + "</span>";
      }
      else {
        document.getElementById("duesDiv").style.display = "none";
        document.getElementById("noDuesDiv").style.display = "block";
        document.getElementById("balanceReceiptDiv").style.display = "none";
        document.getElementById("serverMessage").innerHTML = "<span style='color:red'>" + outstandingData.message + "</span>";

      }
    },
    payNow() {
      var mobileNo = document.getElementById("mobileNo").value;
      var emailId = document.getElementById("emailId").value;
      if (emailId == "")
        emailId = "NA";

      if (mobileNo.length != 10) {
        this.$bvToast.toast('Enter 10 Digit Mobile Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("mobileNo").focus();
        return;
      }

      var dataToSend = {
        "consNo": consNo,
        "mobileNo": mobileNo,
        "email": emailId,
      }
      document.getElementById("consBillDiv").style.display = "none";
      document.getElementById("billdeskRequestDiv").style.display = "block";
      var parent = this;
      axios.post(this.$urlCommon + '/api/v2/onlineprepaid/clearOutstanding/pgrequest', dataToSend)
        .then((response) => {
          console.log(response.data);

          var data = response.data;
          var msg = response.data.message;

          if (msg == "00") {
            parent.reqUrl = data.action;
            parent.messageToSend = data.msg;
            setTimeout(function () { document.getElementById("submit").click(); }, 2000);
          }
          else {
            document.getElementById('spinner').style.display = 'none';
            document.getElementById('errorDiv').style.display = 'block';
            document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
            this.$bvModal.show("model");
            document.getElementById("msg").innerHTML = this.message[parseInt(msg)];
            //document.getElementById("BillDetails").classList.remove("showBillDetails");
          }

        })
        .catch((e) => {
          parent.show = false;
          parent.$bvModal.show('model');
          document.getElementById("msg").innerHTML = "Sorry, Please Try Again Later";
          console.log("Caught :::::::::::::::", e.message);

        })
    },

    viewStatementOld() {
      if (ov == "N") {
        console.log("OTP not verified");
        return;
      }
      if (this.selectedMonth == null) {
        this.$bvToast.toast('Select a Month !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })

        return;
      }
      if (this.selectedYear == null) {
        this.$bvToast.toast('Select a Year !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })

        return;
      }
      /*if(lang==null)
      {
        this.$bvToast.toast('Select a Language !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            
            return;
      }*/


      let shortCode = 'p' + consNo + this.selectedMonth + this.selectedYear;

      window.open('https://www.apdcl.org/tu/?s=' + shortCode, '_blank');
      //window.open('https://www.apdcl.org/tu/?s=' + shortCode, '_blank');

      /*
            if(lang=='ass'){
              window.open('https://www.apdcl.org/pdfEngine/v2/prepaidStatement?consNo='+consNo+'&month='+this.selectedMonth+'&year='+this.selectedYear+'&lang=assamese', '_blank');      
            }
            else
              window.open('https://www.apdcl.org/pdfEngine/v2/prepaidStatement?consNo='+consNo+'&month='+this.selectedMonth+'&year='+this.selectedYear, '_blank');  
            */
    },



    closeModal() {
      this.$bvModal.hide('model')
    },
    closeModalH() {
      this.$bvModal.hide('holdingModal')
    }
  },
  created() {
    window.downloadReceipt = this.downloadReceipt;
    window.downloadReceiptBalance = this.downloadReceiptBalance;
  },

  mounted() {
    const d = new Date();
    let year = d.getFullYear();
    var temp = [{ value: null, text: 'Please Select Year' }];
    // console.log(year);
    for (var i = 2023; i <= parseInt(year); i++) {
      var obj = { value: i, text: i };
      temp.push(obj);
    }

    this.yearOptions = temp;

    axios.post(this.$urlCommon + "/api/web/getCaptcha").then(function (response) {

      document.getElementById("captcha").src = "data:image/png;base64," + response.data;

    })

  }


}


</script>

<style scoped="true">
.blink_me {
  animation: blinker 1s linear infinite;
  font-weight: 600;
}

@keyframes blinker {
  50% {
    /* color:red; */
    opacity: 0;
  }
}

.data {
  font-weight: 600;
  color: #ff5722;
  font-size: 1.2rem;
}

/deep/ .table>tbody>tr>td {
  padding: 0.20rem !important;
}

/deep/ .table>tbody>tr>th {
  padding: 0.20rem !important;
}

max-width: 300px;

.paddingTh {
  padding: 0.20rem !important;
}

.paddingTd {
  padding: 0.20rem !important;
}

.displayProp {
  display: -webkit-box;
}

.inputWidth {
  width: 75%;
  margin-top: -6px;
}

.paddingRow {
  padding: 0.7rem;
}

.paddingLeft {
  padding-left: 0.7rem;
}

.paddingCol {
  padding: none;
}

.label {
  font-weight: 600;
}

.billDetails {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
  margin-right: 1.5rem;
}

.showBillDetails {

  visibility: visible;
  opacity: 1;
}

hr {
  margin-top: 5px;
  margin-bottom: 5px;
}

.go:focus {
  box-shadow: none;
}

.headerF {
  display: block;
}

.headerM {
  display: none;
}

.paddingLeft30px {
  padding-left: 30px;
}

.marginTop {
  margin-top: -8px;
}

@media (max-width: 768px) {
  /deep/ .mobileFont {
    font-size: 12px !important;
  }

  .headerF {
    display: none;
  }

  .headerM {
    display: block;
  }

  .paddingLeft30px {
    padding-left: 0px;
  }

  .displayProp {
    display: block;
  }

  .inputWidth {
    width: 100%;
    margin-top: 0px;
  }

  .marginTop {
    margin-top: 22px;
  }

  /* .paddingCol{
      padding: 0.7rem;
    } */
}

@media only screen and (max-width: 414px) {
  /deep/ .mobileFont {
    font-size: 12px !important;
  }

  .paddingCol {
    padding: 0.7rem;
  }

  .paddingRow {
    padding: none !important;
  }

  .paddingLeft30px {
    padding-left: 0px;
  }

  .displayProp {
    display: block;
  }

  .inputWidth {
    width: 100%;
    margin-top: 0px;
  }

  .marginTop {
    margin-top: 0px;
  }
}
</style>
